__turbopack_context__.v({
  "className": "inter_6ff6a078-module__je0zxa__className",
});
